// Import the Commerce module
import Commerce from "@chec/commerce.js";

// Create a Commerce instance
export const commerce = new Commerce(
  "pk_493254c5ee5dc73c5bdcaa64c1f8321a370eb04d2ab0f"
);
